import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { FormStateType } from '../../../types'
import { Form, Grid, Button } from '../../System'
import ROUTES from '../../utils/routes'
import { SubscriptionSelect } from '../../Auth/SubscriptionSelect'
import { paymentOptions } from '..'
import { AppState } from '../../../redux/root-reducer'
import { AffiliateTrackState } from '../../../redux/affiliate-track/types'

type Props = {
  form: FormStateType;
  nextStep: () => void;
}

const SubscriptionStep: FC<Props> = ({ form, nextStep }) => {
  const { values, setValue } = form
  const { affiliate } = useSelector<AppState, AffiliateTrackState>((state) => state.affiliate)

  return (
    <Form>
      <Grid inLayout gap={12}>
        <SubscriptionSelect
          value={values.subscription}
          subscriptionList={affiliate ? paymentOptions.slice(0, 1) : paymentOptions}
          onChange={(value) => setValue('subscription', value)}
          hideBullets
        />
      </Grid>
      <Button
        isDisabled={!values.subscription}
        type="large"
        className="continue-btn"
        onClick={() => nextStep()}
      >
        CONTINUE
      </Button>
      <span className="auth-prompt">
        Already have an account? <Link to={ROUTES.user.login}>Sign In</Link>
      </span>
    </Form>
  )
}

export default SubscriptionStep
